import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { postsMessages } from './postsMessages';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './Posts.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The line above the board for the example artist (design assets-rethink d2): it is read-only. The
 * watermark banner (design: trial-upsell a4) took the place of the old plan note for every other
 * artist.
 */
const PostsDemoNoteComponent: React.FC = () => {
  const intl = useIntl();
  return (
    <div className={styles.note} data-testid="posts-demo-note">
      {intl.formatMessage(postsMessages.demoNote)}
    </div>
  );
};

export const PostsDemoNote = TypedMemo(PostsDemoNoteComponent);
